document.addEventListener("DOMContentLoaded",(function(n){}));